var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagKazakhstan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.2705C24.8366 32.2705 32 25.1071 32 16.2705C32 7.43395 24.8366 0.270508 16 0.270508C7.16344 0.270508 0 7.43395 0 16.2705C0 25.1071 7.16344 32.2705 16 32.2705Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0431 16.4443H6.95605C6.95605 17.693 8.04362 18.7052 9.29218 18.7052H9.21693C9.21693 19.9539 10.2291 20.9661 11.4778 20.9661C11.4778 22.2148 12.49 23.227 13.7387 23.227H18.2604C19.5091 23.227 20.5213 22.2148 20.5213 20.9661C21.77 20.9661 22.7822 19.9539 22.7822 18.7052H22.7069C23.9554 18.7052 25.0431 17.693 25.0431 16.4443Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2609 13.4878C22.2609 16.9455 19.4578 19.7487 16 19.7487C12.5422 19.7487 9.73914 16.9455 9.73914 13.4878",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7822 13.4877L18.8281 14.4069L19.8687 16.2994L17.7468 15.8934L17.4779 18.0369L16 16.4604L14.522 18.0369L14.2532 15.8934L12.1313 16.2992L13.1718 14.4068L11.2178 13.4877L13.1719 12.5685L12.1313 10.6761L14.2531 11.082L14.5221 8.93848L16 10.515L17.478 8.93848L17.7468 11.082L19.8687 10.6761L18.8282 12.5686L20.7822 13.4877Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.270508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagKazakhstan);
export default __webpack_public_path__ + "static/media/flag_kazakhstan.8a5150c2e66d45f1a7f645f5d8d6d443.svg";
export { ForwardRef as ReactComponent };